export const EXPIRY_FILTERS = [
  { value: 'all', label: 'All expiry' },
  { value: 'expired', label: 'Expired' },
  { value: '30', label: 'Expiring in 30 days' },
  { value: '60', label: 'Expiring in 60 days' },
  { value: '90', label: 'Expiring in 90 days' }
];

export const expiryParams = (value) => {
  if (!value || value === 'all') return {};
  if (value === 'expired') return { expired_only: true };
  return { expiry_within_days: Number(value) };
};

export const exportRowsToCsv = (rows, columns, filename) => {
  const escape = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map(c => escape(c.label)).join(',');
  const body = rows.map(r => columns.map(c => escape(
    typeof c.value === 'function' ? c.value(r) : r[c.key]
  )).join(',')).join('\n');
  const blob = new Blob([`${header}\n${body}`], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
